import FeedMenu from 'src/components/feed_menu/feed_menu.vue'
import { currentFeed } from 'src/components/navigation/feeds.js'
import Popover from 'src/components/popover/popover.vue'

import { useBookmarkFoldersStore } from 'src/stores/bookmark_folders.js'
import { useInterfaceStore } from 'src/stores/interface'
import { useListsStore } from 'src/stores/lists.js'
import { useUsersStore } from 'src/stores/users.js'

const names = {
  listTitle: (id) => useListsStore().findListTitle(id),
  folderName: (id) => useBookmarkFoldersStore().findBookmarkFolderName(id),
}

// The phone bar's feeds button: the icon of the feed on screen, and the feed
// menu under it. On any other page it shows the last feed and goes back to it.
export default {
  components: { FeedMenu, Popover },
  computed: {
    feed() {
      return currentFeed(this.$route, names)
    },
    lastFeed() {
      return (
        useInterfaceStore().lastTimeline || {
          name: useUsersStore().currentUser ? 'friends' : 'public-timeline',
        }
      )
    },
    // what the button shows
    shown() {
      return this.feed || currentFeed(this.lastFeed, names)
    },
    name() {
      return this.shown.labelRaw || this.$t(this.shown.label)
    },
  },
  watch: {
    feed: {
      immediate: true,
      handler(feed) {
        if (feed) useInterfaceStore().setLastTimeline(feed.route)
      },
    },
  },
  methods: {
    back() {
      if (!this.feed) this.$router.push(this.lastFeed)
    },
  },
}
